// extracted by mini-css-extract-plugin
export default {"icon":"SortIcon_icon__QFw0X","asc":"SortIcon_asc__vY-A5","desc":"SortIcon_desc__4I4Vr"};